import { IDadosOportunidade } from "../../../Interfaces/Vendas/Oportunidade/OportunidadeInterface";
import {
    DadosOportunidadeLeadService,
    EditarOportunidadeLeadService,
    InserirNovaOportunidadeLeadService,
} from "../../../Services/Vendas/Oportunidade/OportunidadeService";
import { Controller } from "../../Controller";

export async function InserirNovaOportunidadeLeadController(ID_LEAD: number) {
    return Controller(InserirNovaOportunidadeLeadService(ID_LEAD));
}

export async function EditarOportunidadeLeadController(
    requestBody: IDadosOportunidade
) {
    return Controller(EditarOportunidadeLeadService(requestBody));
}

export async function DadosOportunidadeLeadController(ID_OPORTUNIDADE: number) {
    return Controller(DadosOportunidadeLeadService(ID_OPORTUNIDADE));
}
